<template>
  <layout :drawer="false">
    <template slot="nav">
      <v-tabs>
        <v-tab :to="{ name: 'lead' }">Lead</v-tab>
      </v-tabs>
    </template>
    <template slot="nav-tools">
      <span>
        <v-toolbar
            class="pa-0 ma-0"
            height="48"
            width="100%"
            flat
            style="background: transparent"
        >
          <smart-btn
              v-if="lead?.phoneCallId??null"
              small
              outlined
              rounded
              secondary
              class="mr-4"
              @click.native="loadTranscription(lead.phoneCallId)"
          >
            <v-icon small>mdi-volume-high</v-icon>
            <span class="pl-1">Transcription</span>
          </smart-btn>

          <smart-btn
              class="mr-4"
              small
              outlined
              rounded
              secondary @click.native="dialogs.booking.show = true">
            Rattacher un dossier
          </smart-btn>

          <smart-btn
              class="mr-4" v-if="selectedQuotes.length>0"
              small
              outlined
              rounded
              secondary
              @click.native="sendQuotes(false)">
            Envoyer au client
          </smart-btn>
          <smart-btn
              class="mr-4" v-if="selectedQuotes.length>0"
              small
              outlined
              rounded
              secondary
              @click.native="sendQuotes(true)">
            Relance client
          </smart-btn>

          <smart-btn
              class="mr-4" v-if="selectedQuotes.length>0"
              small
              outlined
              rounded
              secondary
              action="delete" @click.native="dialogs.quotesRemove.show = true">
            Supprimer du Lead
          </smart-btn>
        </v-toolbar>
      </span>
    </template>
    <template slot="drawer"></template>
    <template slot="content">
      <v-row class="pa-1" style="max-height: 60dvh">
        <v-col cols="1"></v-col>
        <v-col cols="5">
          <collapse-panel :fillHeight="false" :collapsable="false" :loading="loading" v-if="lead">
            <div slot="title">
              <v-row align="center">
                <v-col class="caption font-weight-medium">
                  {{ lead.label || "" }} <span class="caption grey--text lighten-1"
                >#{{ lead.id }}</span>
                  <span class="caption grey--text lighten-1"> - Créé le {{
                      _parseAndFormatDate(lead.creationDate, datePatternConfig.serverLocalDateTime, "dd/MM/yyyy HH:mm:ss")
                    }}</span>
                </v-col>

                <v-col class="d-flex justify-end text-right align-center items-center">
                  <ScoreLead :score="lead.score" class="mr-3"/>
                  <v-chip small outlined label
                          :color="lead.status == 'open' ? 'green' : lead.status == 'close' ? 'red' : 'orange'"
                  >
                    {{ $t('lead.status.' + lead.status) }}
                  </v-chip>
                  <v-chip v-if="lead!=null && lead.status == 'close' && lead.failure" small outlined label color="red"
                          class="ml-1">{{ $t('lead.fail.' + lead.failure) }}
                  </v-chip>

                  <v-chip v-if="lead.converted" small outlined label color="green" class="ml-1">Convertis
                    {{ lead.bookingIdCloseOrigin ? "par #" + lead.bookingIdCloseOrigin : "" }}
                  </v-chip>
                </v-col>
              </v-row>
            </div>
            <div slot="header">
              <v-row>
                <v-col cols="6" style="">
                  <div class="d-flex justify-space-between rounded  align-center">
                    <div class="d-flex">
                      <div class="d-flex text-left align-center">
                        <span class="caption grey--text lighten-2">Budget: </span>
                        <span v-if="lead.budget" class="ml-1 font-weight-medium"> {{
                            lead.budget | currency("EUR", lead.budget)
                          }}</span>
                        <span v-else-if="quotations.length>0">{{ maxPrice | currency("EUR", maxPrice) }}</span>
                        <span v-else> - </span>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="6" class="align-self-end text-right float-right">
                  <div class="d-flex justify-end  text-right align-baseline">
                    <div :style="alertBorder" class="px-2 mr-1">
                      <v-icon class="">mdi-account</v-icon>
                      <span :class="[lead.user ? 'body-2' : 'caption']">{{
                          userName()
                        }}</span>
                    </div>
                    <smart-btn v-if="!lead.user" :autocapitalize="false" secondary small @click.native="rattachUser()">
                      Me l'attribuer
                    </smart-btn>
                  </div>
                </v-col>
                <v-col class="body-2 pa-0 pr-2">

                  <div class="d-flex justify-space-between">
                    <div v-if="lead.message != null && lead.message != ''" class="d-flex flex-column rounded py-3"
                         style="">
                      <span class="grey--text lighten-2 caption">Commentaire:</span>
                      <div class="caption" style="overflow-y: scroll; max-height: 45dvh;width:100%"
                           v-html="htmlMessage"></div>
                      <!--                        <div class="caption">{{ htmlMessage }}</div>-->

                    </div>

                  </div>


                </v-col>
                <v-col cols="12" class="pr-2">
                  <div v-if="dialogs.contacts.data.length > 0" class="caption grey--text">Autres contacts:
                    <div v-for="mail in dialogs.contacts.data" :key="mail">
                      - {{ mail }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="pa-0 pr-2">
                  <div class="d-flex justify-space-between">
                    <div class="d-flex ">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                              v-bind="attrs"
                              v-on="on"
                              label
                              flat
                              small
                              outlined
                              class="grey lighten-2 green--text text--lighten-2 mr-1"
                          >
                            <v-icon small class="mr-2">mdi-clipboard-text</v-icon>
                            {{ $t('lead.source.' + lead.source) }}
                          </v-chip>
                        </template>
                        Origine du lead
                      </v-tooltip>
                      <v-chip
                          label
                          flat
                          small
                          outlined
                          class="grey lighten-2 blue--text text--lighten-2  mr-1"
                          v-if="lead.destinations.length >0"
                      >

                        <v-icon small class="mr-2">mdi-tag</v-icon>
                        {{ lead.destinations.map(x => x.name).join(", ") }}
                      </v-chip>

                      <v-chip
                          label
                          flat
                          small
                          outlined
                          class="grey lighten-2 blue--text text--lighten-2 mr-1"
                      >
                        <v-icon small class="mr-2">mdi-phone</v-icon>
                        {{ lead.phonecalls }} appels
                      </v-chip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip
                              v-bind="attrs"
                              v-on="on"
                              label
                              flat
                              small
                              outlined
                              class="grey--text grey lighten-2 text--lighten-1 mr-1"
                          >
                            {{ firstQuoteOrigin }}
                          </v-chip>
                        </template>
                        Origine du premier devis
                      </v-tooltip>
                    </div>
                  </div>
                </v-col>

              </v-row>
            </div>
            <div slot="menu">
              <v-list-item @click="dialogs.infos.show = true">
                <v-list-item-title>
                  <v-icon small>edit</v-icon>
                  <span>Éditer le lead</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="dialogs.converter.show = true" v-if="lead.status != 'close'">
                <v-list-item-title>
                  <v-icon small>mdi-database-check</v-icon>
                  Convertir le lead
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="openDealCloture" v-if="lead.status == 'open'">
                <v-list-item-title>
                  <v-icon small>mdi-database-check
                  </v-icon
                  >
                  Cloturer le lead
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="setStatusLead('open')" v-else>
                <v-list-item-title>
                  <v-icon small>mdi-database-check
                  </v-icon
                  >
                  Réouvrir le lead
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="dialogs.contacts.show = true">
                <v-list-item-title>
                  <v-icon small>edit</v-icon>
                  <span>Ajouter des contacts</span>
                </v-list-item-title>
              </v-list-item>

              <v-list-item @click="sendDirectMail()" :disabled="lead.clientId == null">
                <v-list-item-title>
                  <v-icon small>mail</v-icon>
                  <span>Mail au client</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="sendDirectSms()"
                           :disabled="lead.clientId == null || lead.customer.phone === '' ||lead.customer.phone == null">
                <v-list-item-title>
                  <v-icon small>mail</v-icon>
                  <span>Sms au client</span>
                </v-list-item-title>
              </v-list-item>
            </div>
          </collapse-panel>
        </v-col>
        <v-col cols="5">
          <booking-customer-details style="border: 1px solid lightgray;" v-if="lead"
                                    :booking="lead"
                                    :kagnots="null"
                                    :noTags="true"
                                    :fillHeight="false"
                                    class="mb-2"
                                    urlOverride="/api/lead/customer"
                                    urlSnapchotCustomer="/api/lead"
          ></booking-customer-details>
          <collapse-panel :collapsable="false" :loading="loading" v-if="lead" :fill-height="false"
                          style="max-height:41dvh">
            <div slot="title">
              <h3>
                Historique
                <span class="caption">({{ actions.length }})</span>
              </h3>
            </div>

            <div slot="menu">
              <v-list-item :disabled="lead.status == 'close'" @click="dialogs.action.show = true">
                <v-list-item-title class="">
                  <v-icon small>mdi-database-check
                  </v-icon>
                  <span>Ajouter une action</span>
                </v-list-item-title>
              </v-list-item>
            </div>

            <div slot="content">
              <div v-if="actions.length > 0" style="overflow-y:scroll;max-height:35dvh">
                <div v-for="(action, i) in actions" :key="action.id" class="my-2 px-3">
                  <div class="">
                    <div class="d-flex justify-space-between" style="height:1.5em;">
                      <div class=" items-center"
                           :class="action.type !== 'empty' ? 'font-weight-medium' : ' grey--text'">
                        <v-icon class="mr-1" size="medium">{{ getIcon(action) }}</v-icon>
                        {{ $t("lead.action." + action.type) }}
                      </div>
                      <div class="d-flex caption" v-if="action.type !== 'empty'">
                        <smart-btn
                            v-if="((action.type=='outgoingCall' || action.type=='ingoingCall' )&& action.phonecallId != null) "
                            x-small
                            outlined
                            rounded
                            secondary
                            class="mr-3"
                            @click.native="loadTranscription(action.phonecallId)"
                        >
                          <v-icon small>mdi-volume-high</v-icon>
                        </smart-btn>
                        <p class=" grey--text lighten-1">
                          {{
                            _parseAndFormatDate(action.creationDate, datePatternConfig.serverLocalDateTime, "dd/MM/yyyy HH'h'mm")
                          }}</p>
                        <p v-if="action.user" class="ml-1">• {{ userName(action.user) }}</p>
                      </div>
                    </div>
                    <div class="mb-3 d-flex justify-space-between">
                      <span class="caption">{{ action.message }}</span>
                    </div>
                    <v-divider v-if="i < actions.length - 1" class="mt-3"/>
                  </div>
                </div>
              </div>
              <div v-else>
                    <span class="grey--text">
                      {{ $t("lead.action.empty") }}
                    </span>
              </div>
            </div>
          </collapse-panel>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="10" class="px-4">
          <collapse-panel :collapsable="false" :loading="loading" v-if="lead" class="pt-3" :fill-height="false">
            <div slot="title">
              <h3>Liste des devis</h3>
            </div>
            <div slot="menu">
              <v-list-item :disabled="lead.status == 'close'" @click="$refs.bookingAddDialog.toggle()">
                <v-list-item-title>
                  <v-icon>mdi-folder-plus</v-icon>
                  <span>Créer un devis</span>

                </v-list-item-title>
              </v-list-item>

            </div>
            <template slot="header">
              <v-data-table
                  :headers="quotationsHeaders"
                  :items="quotations"
                  :items-per-page="1000"
                  hide-default-footer
                  no-data-text="Aucuns devis rattaché à ce lead pour le moment"
                  show-select
                  item-key="bookingId"
                  :single-select="false"
                  class="tbl">

                <template #header.data-table-select="{item}">

                  <v-checkbox :value="selectedQuotes.length == quotations.length"
                              @click="selectAllQuotes()"></v-checkbox>
                </template>

                <template #item="{ item }">
                  <tr
                      @click.ctrl="goToBooking(item.bookingId, true)"
                      @click.meta="goToBooking(item.bookingId, true)"
                      @click.exact="goToBooking(item.bookingId, true)">
                    <!---->
                    <td @click.stop>
                      <v-checkbox v-model="item.selected" hide-details class="my-auto"></v-checkbox>
                    </td>
                    <td class="text-left font-weight-regular">
                      <div class="d-flex flex-column">
                        <span class="caption grey--text text-lighten-2">#{{ item.bookingId }}</span>
                        <site-label :sitename="item.virtualSite"></site-label>
                      </div>
                    </td>

                    <td class="text-left font-weight-regular">
                      <div class="d-flex flex-column">
                    <span>{{
                        _parseAndFormatDate(item.creationDate, datePatternConfig.serverLocalDateTime, "dd/MM/yyyy")
                      }}</span>
                        <span
                            class="caption grey--text text-lighten-2">{{
                            _parseAndFormatDate(item.creationDate, datePatternConfig.serverLocalDateTime, "HH'h'mm")
                          }}</span>
                      </div>
                    </td>
                    <td class="text-left font-weight-regular">
                      <div class="d-flex flex-column">
                        <span>{{ item.startDate }}</span>
                        <span class="caption grey--text text-lighten-2">{{
                            item.stopDate
                          }} •{{ duration(item) }}n</span>
                      </div>
                    </td>
                    <td class="text-left font-weight-regular">

                      {{ item.flight.length > 0 ? item.flight.join(", ") : "-" }}
                    </td>
                    <td class="text-left font-weight-regular">
                      <v-icon v-if="item.transfer">mdi-bus-side</v-icon>
                      <span v-else>-</span>
                    </td>
                    <td class="text-left font-weight-regular">
                      {{ item.hotelsName.join(", ") }}
                    </td>
                    <td class="text-left font-weight-regular">
                      <div class="d-flex flex-column">
                        <span class="caption">{{ item.nbAdult }}AD</span>
                        <span class="caption" v-if="item.nbChild > 0">{{ item.nbChild }}CH</span>
                      </div>
                    </td>
                    <td class="text-right font-weight-regular">
                      <p
                          class="d-flex text-truncate flex-column"
                          :class="lead.budget > 0 && item.ca > lead.budget ? 'orange--text': ''">
                        {{ item.ca | currency("EUR") }}
                        <span class="body-2 grey--text">
                              {{ item.purchase | currency("EUR") }}
                              <span class="caption ml-1 grey--text text--lighten-1">{{
                                  item.markup | percent
                                }}</span>
                            </span>
                      </p>
                    </td>
                    <td class="text-right font-weight-regular" @click.stop>
                      <v-tooltip top v-if="item.optionDate != null">
                        <template #activator="{ on }">
                          <v-icon v-on="on" small class="mr-1"
                          >mdi-clock-outline
                          </v-icon
                          >
                        </template>
                        option jusqu'au {{ item.optionDate }}
                      </v-tooltip>
                      <v-chip @click="openDuplicationDialog(item)"
                              label
                              flat
                              small
                              outlined
                              class="grey lighten-2 blue--text text--lighten-2 mr-1"
                      >
                        <v-icon small>mdi-content-duplicate</v-icon>
                      </v-chip>
                    </td>

                  </tr>
                </template>
              </v-data-table>
            </template>
          </collapse-panel>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="1"></v-col>
        <v-col cols="10" class="px-4">
          <collapse-panel :collapsable="true" :loading="loading" class="pt-3" :fill-height="false">
            <div slot="title">
              <h3 class="">Liste des dossiers</h3>
            </div>

            <template slot="header">
              <v-data-table
                  :headers="bookingsHeaders"
                  :items="bookings"
                  :items-per-page="1000"
                  hide-default-footer
                  no-data-text="Aucuns dossiers réservés par ce client"
                  item-key="bookingId"
                  :single-select="false"
                  class="tbl">


                <template #item="{ item }">
                  <tr @click="goToBooking(item.bookingId,true)">

                    <td class="text-left font-weight-regular">
                      <div class="d-flex flex-column">
                        <span class="caption grey--text text-lighten-2">#{{ item.bookingId }}</span>
                        <site-label :sitename="item.virtualSite"></site-label>
                      </div>
                    </td>

                    <td class="text-left font-weight-regular">
                      <div class="d-flex flex-column">
                    <span>{{
                        _parseAndFormatDate(item.creationDate, datePatternConfig.serverLocalDateTime, "dd/MM/yyyy")
                      }}</span>
                        <span
                            class="caption grey--text text-lighten-2">{{
                            _parseAndFormatDate(item.creationDate, datePatternConfig.serverLocalDateTime, "HH'h'mm")
                          }}</span>
                      </div>
                    </td>
                    <td class="text-left font-weight-regular">
                      <div class="d-flex flex-column">
                        <span>{{ item.startDate }}</span>
                        <span class="caption grey--text text-lighten-2">{{
                            item.stopDate
                          }} •{{ duration(item) }}n</span>
                      </div>
                    </td>
                    <td class="text-left font-weight-regular">

                      {{ item.flight != null && item.flight.length > 0 ? item.flight.join(", ") : "-" }}
                    </td>
                    <td class="text-left font-weight-regular">
                      <v-icon v-if="item.transfer">mdi-bus-side</v-icon>
                      <span v-else>-</span>
                    </td>
                    <td class="text-left font-weight-regular">
                      {{ item.hotelsName.join(", ") }}
                    </td>
                    <td class="text-left font-weight-regular">
                      <div class="d-flex flex-column">
                        <span class="caption">{{ item.nbAdult }}AD</span>
                        <span class="caption" v-if="item.nbChild > 0">{{ item.nbChild }}CH</span>
                      </div>
                    </td>
                    <td class="text-right font-weight-regular">
                      <p
                          class="d-flex text-truncate flex-column"
                          :class="lead.budget > 0 && item.ca > lead.budget ? 'orange--text': ''">
                        {{ item.ca | currency("EUR") }}
                        <span class="body-2 grey--text">
                              {{ item.purchase | currency("EUR") }}
                              <span class="caption ml-1 grey--text text--lighten-1">{{
                                  item.markup | percent
                                }}</span>
                            </span>
                      </p>
                    </td>

                  </tr>
                </template>
              </v-data-table>
            </template>
          </collapse-panel>
        </v-col>
      </v-row>


      <booking-add ref="bookingAddDialog" :afterCreationFn="rattachCustomer"/>

      <smart-dialog
          v-model="dialogs.infos.show"
          title="Éditer lead"
      >
        <LeadCreationDialog :lead-info="lead" @done="() => closeEditionDialog()"/>
        <template title="actions">
          <v-card-actions class="actions-btn mt-4">
            <v-spacer/>
            <smart-btn type="submit" form="creation-lead">
              <v-icon small class="mr-1">mdi-content-save</v-icon>
              Sauvegarder
            </smart-btn>
          </v-card-actions>
        </template>
      </smart-dialog>
      <smart-dialog
          v-model="dialogs.action.show"
          title="Ajouter une action"
      >
        <lead-action-creation :lead="lead" @done="() => closeActionDialog()" v-if="dialogs.action.show"/>
      </smart-dialog>
      <smart-dialog
          v-model="dialogs.closer.show"
          title="Cloturer le lead"
          v-if="lead != null"
      >
        <v-form id="close-form" class="pa-4">
          <v-select v-if="lead" v-model="lead.failure"
                    :items="failTypes"
                    item-value="id"
                    item-text="label"
                    label="Raison de la cloture"
                    dense
                    hide-details
                    placeholder=""
                    class="mb-4"/>
          <mail-composer v-if="lead.failure == 'missing' && hasQuotes" :loading="dialogs.mail.loading" ref="clotureMailComposer"
                         :subject="mailToCloseLeadForMissing.subject"
                         :message="mailToCloseLeadForMissing.message"
                         :tos="mailToCloseLeadForMissing.to"
                         @send="(mail) => sendEmail(mail,true)"
                         style="border:1px solid lightgray; border-radius:16px 16px 1px 1px;box-shadow:1px 1px 1px lightgrey;"
                         hideSendBtn
          />
        </v-form>
        <template #actions>
          <v-card-actions class="actions-btn ">
            <v-spacer/>
            <smart-btn v-if="lead.failure == 'missing' && hasQuotes" primary class="mr-2" :loading="dialogs.mail.loading" @click.native="sendAndCloseLead()">
              <v-icon small class="mr-1">send</v-icon>
              Envoyer et cloturer
            </smart-btn>
            <smart-btn :secondary="lead.failure == 'missing' && hasQuotes"  :loading="dialogs.mail.loading" @click.native="setStatusLead('close')">
              Cloturer
            </smart-btn>
          </v-card-actions>
        </template>

      </smart-dialog>
      <smart-dialog
          v-model="dialogs.converter.show"
          title="Convertir le lead">
        <v-form id="converter-form" class="pa-4 mb-4"
                v-on:submit.prevent="closeLeadWithBookingId">
          <v-text-field v-if="lead" v-model="lead.bookingIdCloseOrigin"
                        label="Ref dossier reservé"
                        dense
                        :rules="rules.number()"
                        hide-details/>
          <span class="caption text--red" v-if="dialogs.converter.error">{{ dialogs.converter.error }}</span>
        </v-form>
        <template #actions>
          <v-card-actions class="actions-btn ">
            <v-spacer/>
            <smart-btn type="submit" v-if="lead" form="converter-form"
                       :disabled="isNaN(lead.bookingIdCloseOrigin) || (lead.bookingIdCloseOrigin && lead.bookingIdCloseOrigin.length == 0)">
              Valider
            </smart-btn>
          </v-card-actions>
        </template>

      </smart-dialog>
      <smart-dialog v-model="dialogs.quotesRemove.show" title="Supprimer devis du lead">
        <div class="pa-4">
          Supprimer ces devis du lead ?
        </div>
        <template>
          <v-card-actions class="actions-btn ">
            <v-spacer/>
            <smart-btn secondary @click.native="dialogs.quotesRemove.show = false">
              Annuler
            </smart-btn>
            <smart-btn action="delete" @click.native="detachQuotes(null, null)">
              Supprimer
            </smart-btn>
          </v-card-actions>
        </template>
      </smart-dialog>
      <smart-dialog v-model="dialogs.booking.show" title="Rattacher un dossier" @close="resetRattachmentDialog()">
        <div class="pa-4">
          <v-text-field dense
                        type="number"
                        v-model="dialogs.booking.id"
                        label="Référence dossier"/>
          <div v-if="alreadyAttached.msg != null" v-html="alreadyAttached.msg"
               class="d-flex flex-column"></div>
        </div>
        <template>
          <v-card-actions class="actions-btn ">
            <v-spacer/>
            <smart-btn secondary @click.native="dialogs.booking.show = false">
              Annuler
            </smart-btn>
            <smart-btn v-if="alreadyAttached.code === 'quote.already.attached' "
                       @click.native="detachAndrattachBooking()"
                       :loading="dialogs.booking.loading">
              Rattacher
            </smart-btn>
            <smart-btn v-else @click.native="rattachBooking()" :loading="dialogs.booking.loading">
              Valider
            </smart-btn>
          </v-card-actions>
        </template>
      </smart-dialog>
      <smart-dialog
          title="Sms au client"
          v-model="dialogs.sms.show"
      >
        <sms-composer
            v-if="dialogs.sms.show"
            :loading="dialogs.sms.loading"
            :list="formattedQuotations.length > 0 ? [formattedQuotations[0]] : []"
            :message="dialogs.sms.message"
            :lead="lead"
            @send="sendSms"
        ></sms-composer>
      </smart-dialog>
      <smart-dialog
          title="Message au client"
          v-model="dialogs.mail.show"
          :width="800"
          v-if="lead"

      >
        <mail-composer
            :tos="dialogs.contacts.data.length > 0 ? [lead.customer.email, ...dialogs.contacts.data] : [lead.customer.email]"
            :loading="dialogs.mail.loading"
            :site-id="1"
            :default-internal-attachment="dialogs.mail.type ? [dialogs.mail.type] : []"
            :subject="dialogs.mail.subject || 'réfs. #' + selectedQuotes.map(q => q.bookingId).join(', #')"
            :message="dialogs.mail.message"
            @send="sendEmail"
            :force-disabled="dialogs.mail.error"
            :message-error="dialogs.mail.error ? dialogs.mail.errorMsg : null"
            showInternalAttachment
        />
      </smart-dialog>
      <smart-dialog title="Mails de contact"
                    v-model="dialogs.contacts.show"
                    :width="500">

        <v-combobox
            class="ma-4"
            v-model="dialogs.contacts.data"
            chips
            deletable-chips
            label="Adresses mail"
            multiple
            hide-details
            append-icon
            :rules="[...rules.nonEmptyArray(), ...rules.emailArray()]"
        ></v-combobox>

        <template #actions>
          <smart-btn @click.native="saveContacts">Enregistrer</smart-btn>
        </template>
      </smart-dialog>
      <smart-dialog v-model="dialogs.duplicate.show" :width="320"
                    v-on:close="dialogs.duplicate.booking = null"
                    title="Dupliquer le dossier">
        <booking-duplication-dialog
            v-if="dialogs.duplicate.booking"
            :booking="dialogs.duplicate.booking"
            :show="dialogs.duplicate.show"
            :onDuplicate="(data) => afterDuplicate(data)"/>

      </smart-dialog>
      <smart-dialog v-model="dialogs.transcription.show" title="Une transcription est disponible"
                    @onclose="dialogs.transcription.phoneCallId = null">
        <template #default>
          <Chatting :transcription="transcription"/>
        </template>
        <template #actions>
          <v-card-actions class="actions-btn ">
            <v-spacer/>
            <smart-btn secondary @click.native="dialogs.transcription.show = false">
              Annuler
            </smart-btn>
            <smart-btn @click.native="resumeTranscription">
              Générer un résumé auto
            </smart-btn>
          </v-card-actions>
        </template>
      </smart-dialog>
    </template>
  </layout>
</template>
<script>
import Layout from "@/views/Layout.vue";
import {get, post} from "@/utils/api";
import SiteLabel from "@/components/commons/SiteLabel.vue";
import ScoreLead from "@/components/booking/ScoreLead.vue";
import LeadCreationDialog from "@/views/lead/LeadCreationDialog.vue";
import CollapsePanel from "@/components/commons/CollapsePanel.vue";
import BookingCustomerDetails from "@/components/booking/BookingCustomerDetails.vue";
import {EventBus} from "@/components/commons/event-bus";
import BookingAdd from "@/components/booking/BookingAdd.vue";
import LeadActionCreation from "@/views/lead/LeadActionCreation.vue";
import MailComposer from "@/components/commons/MailComposer.vue";
import FormMixin from "@/components/mixins/FormMixin";
import BookingDuplicationDialog from "@/components/booking/BookingDuplicationDialog.vue";
import Chatting from "@/components/commons/Chatting.vue";
import SmsComposer from "@/components/commons/SmsComposer.vue";


export default {
  name: "Lead",
  components: {
    SmsComposer,
    Chatting,
    BookingDuplicationDialog,
    MailComposer,
    LeadActionCreation,
    BookingAdd,
    SiteLabel,
    BookingCustomerDetails,
    ScoreLead,
    CollapsePanel,
    Layout,
    LeadCreationDialog,
  },
  mixins: [FormMixin],
  data() {
    return {
      lead: null,
      quotations: [],
      firstQuoteOrigin: null,
      actions: [],
      failTypes: [],
      users: [],
      bookings: [],
      quotationsHeaders: [
        {
          text: "Site",
          value: "bookingId",
          align: "left",
          sortable: true,
        },
        {
          text: "Création",
          value: "creationDate",
          align: "left",
          sortable: true,
        },
        {
          text: "Séjour",
          value: "startDate",
          align: "left",
          sortable: true,
        },
        {
          text: "Vols",
          value: "flight",
          align: "left",
          sortable: true,
        },
        {
          text: "Trsf.",
          value: "transfer",
          align: "left",
          sortable: true,
        },
        {
          text: "Hotels",
          value: "hotelsName",
          align: "left",
          sortable: true,
        },
        {
          text: "Pax",
          value: "pax",
          align: "left",
          sortable: false,
        },
        {
          text: "Montant",
          value: "ca",
          align: "right",
          sortable: true,
        },
        {
          text: "",
          value: "",
          align: "",
          sortable: false
        },
      ],
      bookingsHeaders: [
        {
          text: "Site",
          value: "bookingId",
          align: "left",
          sortable: true,
        },
        {
          text: "Résa",
          value: "bookingDate",
          align: "left",
          sortable: true,
        },
        {
          text: "Séjour",
          value: "startDate",
          align: "left",
          sortable: true,
        },
        {
          text: "Vols",
          value: "flight",
          align: "left",
          sortable: true,
        },
        {
          text: "Trsf.",
          value: "transfer",
          align: "left",
          sortable: true,
        },
        {
          text: "Hotels",
          value: "hotelsName",
          align: "left",
          sortable: true,
        },
        {
          text: "Pax",
          value: "pax",
          align: "left",
          sortable: false,
        },
        {
          text: "Montant",
          value: "ca",
          align: "right",
          sortable: true,
        },
      ],
      loading: false,
      bookingToDuplicate: null,
      alreadyAttached: {
        id: null, msg: null, code: null
      },
      transcription: null,
      dialogs: {
        duplicate: {
          show: false,
          id: null
        },
        converter: {
          error: null,
          show: false
        },
        closer: {
          show: false,
          mail: {
            from: 'contact@hotelissima.fr',
            loading: true,
            subject: null,
            type: null,
            message: "",
            to: [],
            cc: [],
            cci: [],
            internalAttachments: [],
            error: false,
            errorMsg: null,
          }
        },
        infos: {
          show: false
        },
        action: {
          show: false
        },
        quotesRemove: {
          show: false,
          loading: false
        },
        sms: {
          show: false,
          message: '',
          to: [],
          error: false,
          errorMsg: null,
        },
        mail: {
          show: false,
          loading: false,
          subject: null,
          type: 'quotation',
          message: "",
          to: [],
          error: false,
          errorMsg: null,
        },
        contacts: {
          show: false,
          data: [],
        },
        booking: {
          show: false,
          id: null
        },
        transcription: {
          show: false,
          phoneCallId: null

        },

      },
      rattachCustomer: (idBooking) => {
        if (this.lead.customer.id != null) {
          return get(`/api/booking/attachcustomer/${idBooking}/${this.lead.customer.id}`).json(() => {
            return Promise.resolve()
          })
        } else {
          return Promise.resolve()
        }
      },
    }
  },
  created() {
    this.init()
    EventBus.$on("reloadLead", (msg) => {
      this.init();
    });

  },
  computed: {
    hasQuotes(){
      return this.quotations != null && this.quotations.length > 0
    },
    formattedQuotations() {
      return this.quotations.map((quote, index) => {
        return {
          id: quote.bookingId,
          customer: {email: this.lead.customer.email},
          siteId: quote.siteId
        }
      })
    },
    maxPrice() {
      if (this.quotations.length > 0) {
        return this.quotations.map(q => q.ca).sort((a, b) => b - a)[0];
      } else return "-"
    },
    htmlMessage() {
      return `<p>${this.lead.message.replaceAll("\n", "<br/>")}</p>`
    },
    selectedQuotes() {
      return this.quotations.filter(quote => quote.selected)
    },
    alertBorder() {
      return this.lead.user ? '' : ' border: 1px solid red; border-radius:4px; height:28px; padding-top:2px'
    },
    mailToCloseLeadForMissing() {
      const allDestiQuotes = this.quotations.flatMap(q => {
        return q.destinations
      })

      const destinations = this.uniquDesti(allDestiQuotes)
      //const ref = this.quotations.map(quote => quote.bookingId)
      let mail = this.dialogs.closer.mail

      mail.subject = `Réf # - Clôture de votre projet`
      mail.message = `
      <p>Vous avez reçu une proposition de séjour à ${destinations.join(", ")}.</p>
      <p>J'ai tenté de vous joindre par mail pour savoir si cette proposition répondait à vos attentes.</p>
      <p>Sans nouvelles de votre part, je me permets de classer votre demande.</p>
      <p>Toutefois, n'hésitez pas à revenir vers nous si vous souhaitez actualiser les propositions !</p>
      <p>Je reste à votre disposition,</p>
      <p>Bonne journée !</p>
      <p>${this.lead?.user?.firstname ?? ""}</p>
      `
      mail.to = [this.lead.customer.email]

      return mail
    }
  },
  methods: {
    init() {
      const url = `/api/lead/${this.$route.params.id}`

      const loadingLead = this.loadLead()

      const loadingQuotes = get(url + "/quotations").json((rs) => {
        this.quotations = rs.map((r, index) => {
          if (index == 0) {
            this.firstQuoteOrigin = r.context.source
          }
          return {
            ...r,
            selected: false
          }
        })
      })

      const loadActions = get(url + "/actions").json((rs) => {
        if (rs.length > 0) {
          this.actions = rs
        } else {
          this.actions = []
        }


      })

      const loadFailTypes = get("/api/lead/failure/types").json((rs) => {
        this.failTypes = rs.map(f => {
          return {id: f, label: this.$t("lead.fail." + f)}
        })
      })

      const loadUsers = get("/api/search/users").json(rs => {
        this.users = rs
      })

      return Promise.all([
        loadingLead, loadingQuotes, loadActions, loadFailTypes, loadUsers
      ]).then(() => {

        if (this.lead.clientId != null) {
          get(`/api/lead/bookings/${this.lead.clientId}/repeater`).json((rs) => {
                this.bookings = rs
              }
          )
        }

        this.loading = false
        return;
      });
    },
    loadLead() {
      const url = `/api/lead/${this.$route.params.id}`
      return get(url).json((rs) => {
        if (rs.customer == null) {
          rs.customer = {id: null}
        }
        this.lead = rs
        this.dialogs.contacts.data = this.lead.contacts.map(obj => obj.mail)
      })
    },
    sendAndCloseLead() {
      const composer = this.$refs.clotureMailComposer
      composer.send()
    },
    closeDuplicateDialogs() {

      this.dialogs.duplicate.show = false
      this.init()
    },
    openDuplicationDialog(item) {
      const dateFormatted = this._parseAndFormatDate(item.startDate, "dd/MM/yyyy", "dd/MM/yyyy 00:00:00")
      let booking = {
        ...item,
        id: item.bookingId,
        startDate: dateFormatted
      }
      this.bookingToDuplicate = item.bookingId
      this.dialogs.duplicate = {
        booking: booking,
        show: true,
        id: item.id
      }
    },
    afterDuplicate(data) {
      this.dialogs.booking.id = data
      this.addAction(
          {
            creationDate: null,
            type: 'update',
            message: `Duplication du dossier #${this.bookingToDuplicate} vers le #${data}`,
            leadId: this.lead.id,
            user: this.users.find(u => u.id === this.currentUser.id),
            bookingId: null,
            phonecallId: null,
          }
      )
      this.loadingDetail = false;
      this.bookingToDuplicate = null
      this.init()
    },
    detachQuotes(otherLead, bookingId) {
      this.dialogs.quotesRemove.loading = true
      const url = `/api/lead/${otherLead != null ? otherLead : this.lead.id}/detach/quotations`
      post(url, {ids: bookingId != null ? [bookingId] : this.selectedQuotes.map(quote => quote.bookingId)}).json((nb) => {
        this.init().then(() => {
          this.dialogs.quotesRemove.show = false
          EventBus.$emit("toaster-msg", `Détachement de ${nb} devis effectuée`)
          if (otherLead != null && bookingId != null) {
            this.rattachBooking()
          }
          return nb
        }).catch(err => EventBus.$emit("toaster-error", "Erreur lors de la suppression"))
      })
    },
    detachAndrattachBooking() {
      this.dialogs.booking.loading = true
      this.detachQuotes(this.alreadyAttached.id, this.dialogs.booking.id)
      this.alreadyAttached = {id: null, msg: null}
    },
    rattachBooking() {
      this.dialogs.booking.loading = true
      post(`/api/lead/${this.lead.id}/add/quotations/${this.dialogs.booking.id}`)
          .badRequest((err) => {
            const error = JSON.parse(err.toString().split(": ")[1])
            this.alreadyAttached.id = error.leadId
            this.alreadyAttached.code = error.msg

            switch (error.msg) {
              case "quote.already.attached":
                this.alreadyAttached.msg = `<span class="red--text">${this.$t('lead.attachFailed.already', {id: error.leadId})}</span>
                    <span>${this.$t('lead.attachFailed.rattach')}</span>`
                break;
              case "quote.not.hotelissima":
                this.alreadyAttached.msg = `<span class="red--text">${this.$t('lead.attachFailed.notHotelissima')}</span>`
                break;
              case "quote.not.exist":
                this.alreadyAttached.msg = `<span class="red--text">${this.$t('lead.attachFailed.notExist')}</span>`
                break;
              case "quote.not.added":
                this.alreadyAttached.msg = `<span class="red--text">${this.$t('lead.attachFailed.notAdded')}</span>`
                break;
              default:
                this.alreadyAttached.msg = `<span class="red--text">{{error.msg}}</span>`

            }
            EventBus.$emit("toaster-error", "Impossible!")
            this.dialogs.booking.loading = false
          })
          .json(() => {
            this.init().then(() => {
              this.dialogs.booking.loading = false
              this.dialogs.booking.id = null
              this.dialogs.booking.show = false
            })

          })
    },
    rattachUser() {
      const userId = this.currentUser.id
      get(`/api/lead/${this.lead.id}/attach/user/${userId}`).json(() => {
        this.init()
      })

    },
    goToBooking(id, newTab = false) {
      if (newTab) {
        let route = this.$router.resolve({
          name: "Booking",
          params: {id: id},
        });
        window.open(route.href, "_blank");
        return false;
      } else {
        this.$router.push({name: "Booking", params: {id: id}});
      }
    },
    duration(item) {
      const start = this._parseDate(item.startDate, "dd/MM/yyyy")
      const stop = this._parseDate(item.stopDate, "dd/MM/yyyy")
      return this._duration(start, stop, 'days')
    },
    async closeLeadWithBookingId() {
      this.dialogs.converter.error = null
      await get(`/api/booking/${this.lead.bookingIdCloseOrigin}`).json(async (rs) => {
        if (rs.status === "Success") {
          this.lead.bookingIdCloseOrigin = parseInt(this.lead.bookingIdCloseOrigin)
          await post(`/api/lead/${this.lead.id}`, this.lead).json(async (rs) => {
            this.lead = rs
            await get(`/api/lead/${this.lead.id}/convert`).res(() => {
              this.dialogs.converter.show = false
              EventBus.$emit("toaster-msg", `Lead cloturé`)

              this.init()
            })
          })

        } else {
          this.dialogs.converter.error = `les dossier n°${this.lead.bookingIdCloseOrigin} n'existe pas`
        }
      })
    },
    addAction(data) {
      post("/api/lead/add/action", data).json(() => {
        this.init()
      })
    },
    closeEditionDialog() {
      this.dialogs.infos.show = false
      this.loadLead()
    },
    closeActionDialog() {
      this.dialogs.action.show = false
    },
    setStatusLead(to) {
      let toStatus = ''
      let toastMsg = ''
      switch (to) {
        case 'open':
          toastMsg = 'réouvert'
          toStatus = "open"
          break;
        case 'close':
          toastMsg = 'cloturé'
          toStatus = "close"
          break;
        case 'pending':
          toastMsg = 'en attente client'
          toStatus = "pending"
          break;
      }
      let endPath = this.lead.failure && toStatus === 'close' ? "/" + this.lead.failure : ""

      get(`/api/lead/${this.lead.id}/${toStatus}${endPath}`).res(() => {
        this.dialogs.closer.show = false
        EventBus.$emit("toaster-msg", `Lead ${toastMsg}`)
        this.init()

      })
    },
    resetRattachmentDialog() {
      this.alreadyAttached = {id: null, msg: null}
      this.dialogs.booking.id = null
      this.dialogs.booking.loading = false
    },
    getIcon(action) {
      switch (action.type) {
        case 'update':
          return "mdi-update";
        case 'ingoingCall':
          return "mdi-phone-incoming";
        case 'outgoingCall':
          return "mdi-phone-outgoing"
        case 'email':
          return "mdi-mail";
        case 'proposition':
          return "mdi-currency-eur";
        case 'option':
          return 'mdi-clock-outline';
        case'relance':
          return 'mdi-refresh';
      }
    },
    userName(user) {
      if (this.lead.user && user == null) {
        return `${this.lead.user.firstname[0]}. ${this.lead.user.lastname}`
      } else if (user != null) {
        return `${user.firstname[0]}. ${user.lastname}`
      } else {
        return "Aucun agent affecté"
      }
    },
    sendEmail(mail, closeLead = false) {
      this.dialogs.mail.loading = false;
      const body = {
        email: {...mail, externalAttachments: []},
        leadId: this.lead.id,
      }

      let url = "/api/lead/mail/sendQuotations";
      if (this.dialogs.mail.type === 'quotation') {
        body.bookingIds = this.selectedQuotes.map(quote => quote.bookingId)

      } else if (!this.dialogs.mail.type) {
        url = "/api/lead/mail/send"
        body.bookingIds = this.quotations.map(quote => quote.bookingId)
      }

      post(url, body)
          .json((r) => {
            EventBus.$emit("toaster-msg", "Email envoyé");
            this.init()
            return r;
          })
          .then(() => {
            if (closeLead) this.setStatusLead('close')
            this.dialogs.mail.loading = false;
            this.dialogs.mail.show = false;
          });

    },
    saveContacts() {
      const body = this.dialogs.contacts.data.map(email => {
        return {mail: email}
      })

      post(`/api/lead/${this.lead.id}/contacts`, body).json(rs => {
        this.dialogs.contacts.show = false
        this.init()
      })
    },
    sendQuotes(isRelance) {
      const selections = this.quotations.filter(quote => quote.selected)
      const error = selections.some(q => q.customerId == null)
      this.dialogs.mail.message = this.buildQuoteMail(selections, isRelance)
      this.dialogs.mail.type = 'quotation'

      this.dialogs.mail.show = true
      this.dialogs.mail.error = error
      this.dialogs.mail.errorMsg = "Au moins un des devis n'est pas rattaché à un client " + (error ? `(#${selections.filter(s => s.customerId == null).map(q => q.id).join(", #")})` : '')
    },
    sendDirectMail() {
      this.dialogs.mail.subject = 'Contact Hotelissima'
      this.dialogs.mail.type = null
      this.dialogs.mail.message = null
      this.dialogs.mail.show = true
      this.dialogs.mail.error = false
      this.dialogs.mail.errorMsg = null

    },
    sendDirectSms() {
      const sign = this.lead.user != null ? [this.lead.user.firstname, this.lead.user.lastname].join(" ") : ""

      this.dialogs.sms.message =
          `Bonjour ${this.lead.customer.firstname} ${this.lead.customer.lastname},
Je me permets de revenir vers vous concernant votre projet de voyage. Souhaitez-vous que nous finalisions ensemble les détails ? N'hésitez pas à me revenir, je reste à votre disposition.
\r
N'hésitez pas à nous solliciter \r${sign}`
      this.dialogs.sms.show = true
      this.dialogs.sms.error = false
      this.dialogs.sms.errorMsg = null
    },
    sendSms(composer) {

      const sms = {
        bookingId: this.quotations.map(quote => quote.bookingId)[0],
        leadId: this.lead.id,
        siteId: this.formattedQuotations.length > 0 ? this.formattedQuotations[0].siteId : null,
        message: composer.message,
        virtualSite: this.lead.virtualSite
      }
      post("/api/sms/bulk", [sms])
          .badRequest((err) => {
            if (err.text == 'missing-Client-phone-country') {
              EventBus.$emit("toaster-error", "Veuillez modifier les informations du client: pays du numéro de télephone");
            } else {
              EventBus.$emit("toaster-error", this.$t("error-500"));
            }
          })
          .json((nb) => {
            if (nb > 0) {
              EventBus.$emit('toaster-msg', ` ${nb} ${nb > 1 ? 'Messages envoyés':'Message envoyé'}`)
            } else {
              EventBus.$emit('toaster-error', "Erreur: O Message envoyé")
            }
            this.dialogs.sms.show = false
            this.init()
          })
    },


    buildQuoteMail(quotes, isRelance) {

      let destinations = this.uniquDesti(quotes.flatMap(q => q.destinations))

      if (destinations.length > 1) {
        const combined = destinations.at(-2) + " et " + destinations.at(-1)
        destinations.splice(-2, 2)
        destinations.push(combined)

      }
      const refs = quotes.map(b => b.bookingId).join(',#')
      const suffix = isRelance ? '-  Besoin d’aide pour finaliser votre projet ?' : ''

      this.dialogs.mail.subject = `Réf #${refs} Votre devis pour ${destinations} ${suffix}`
      const lastQuote = quotes.map(q => q.creationDate).sort((a, b) => this._sortDates(a, b, "dd/MM/yyyy HH:mm:ss"))[quotes.length - 1].split(" ")[0]

      const templateRelance =  `
      <p>Je me permets de vous recontacter concernant les devis que vous avez reçu le ${lastQuote} pour votre futur voyage à ${destinations.join(', ')}.</p>
      <p>J'aimerais simplement savoir si vous avez eu le temps d'en prendre connaissance et si tout vous convient. Attention, les tarifs et disponibilités sont soumis à modifications tant qu'aucune réservation ou option n'a été faite.</p>
      <p>Je reste bien sûr à votre entière disposition pour ajuster certains points ou répondre à toutes vos questions. L'objectif est que ce voyage vous corresponde à 100 %.</p>
        <br/>
      <p>N'hésitez pas à revenir vers moi quand vous le souhaitez.</p>
      <p>À Bientôt</p>
      <p>${this.lead?.user?.firstname ?? ""}</p>
      `;

      const templateContact = `
      <p>Je fais suite à notre conversation téléphonique.</p>
      <p>Je vous remercie de trouver en pièce jointe ${this.selectedQuotes.length} devis à <strong>${destinations.join(", ")}</strong>.</p>
      <p>Si vous souhaitez apporter des modifications n'hésitez pas à revenir vers moi.</p>
      <p>Je reste à votre disposition pour tout complément d'information</p>
      <p>Cordialement</p>
      <p>${this.lead?.user?.firstname ?? ""}</p>
      `;

      return isRelance ? templateRelance : templateContact
    },
    selectAllQuotes() {

      if (this.quotations.length != this.selectedQuotes.length) {
        this.quotations.map(q => q.selected = true)
      } else {
        this.quotations.map(q => q.selected = false)
      }
    },
    loadTranscription(phoneCallId) {

      if (this.transcription == null) {
        get(`/api/phonecall/${phoneCallId}/get-transcription`)
            .json((res) => {
              this.transcription = res
              this.dialogs.transcription.phoneCallId = phoneCallId
            })
      }

      this.dialogs.transcription.show = true
    },
    resumeTranscription() {
      //call xhr
      this.dialogs.transcription.show = false
      EventBus.$emit('snackbarTranscription', {
        show: true,
        done: false,
        leadId: this.lead.id
      })
      const idToUrl = this.dialogs.transcription.phoneCallId ?? this.lead.phoneCallId
      post(
          `/api/phonecall/${idToUrl}/summarize-transcription/lead/${this.lead.id}`
      ).badRequest((err) => {
        EventBus.$emit('toaster-msg', "Une erreur a eu lieu. Veuillez contact l'administrateur")
      })
          .res(() => {
            EventBus.$emit('snackbarTranscription', {
              show: true,
              done: true,
              leadId: this.lead.id
            })
          })
    },
    uniquDesti(destinationArr){
    return destinationArr.reduce((prev,acc)=> {
        if(!prev.map(a => a.id).includes(acc.id)){
          prev.push(acc)
        }
        return prev
      },[]).map(desti => desti.customerName)
  },
    openDealCloture() {
      this.dialogs.mail.type=null;
      this.dialogs.closer.show = true;
    }
  },
  destroyed() {
    EventBus.$off('reloadLead')
  }

}
</script>
<style scoped>

.messages {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  height: calc(100vh / 2);
}

.message {
  background-color: rgb(243, 244, 246);
  border: 1px solid rgb(243, 244, 246);
  border-radius: 12px 0 12px 12px;
  display: flex;
  flex-direction: column;
  width: 75%;
  justify-self: end;
}

.message.reverse {
  border: 1px solid rgb(243, 244, 246);
  border-radius: 0 12px 12px 12px;
  justify-self: start;
}
</style>